module.exports = __webpack_public_path__ + "static/media/LittleSquirts.28550393.jpg";